import React from 'react';
import { Edit as Edit3Icon, PowerSettingsNew as PowerIcon } from '@mui/icons-material';
import { T, fontBody } from '../tokens';

export default function TemplateCardActions({ template, onEdit, onToggleStatus, toggling }) {
  const isActive = template.status === 'Active';

  return (
    <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexShrink: 0 }}>
      <button
        type="button"
        disabled={toggling}
        onClick={() => onToggleStatus(template)}
        style={{
          display: 'flex', alignItems: 'center', gap: 5,
          fontFamily: fontBody, fontSize: 12.5, fontWeight: 600,
          border: `1px solid ${isActive ? T.line : T.blue}`,
          background: isActive ? 'transparent' : T.blue,
          color: isActive ? T.slate : '#fff',
          padding: '7px 11px', borderRadius: 8, cursor: toggling ? 'not-allowed' : 'pointer',
          opacity: toggling ? 0.6 : 1,
        }}
      >
        <PowerIcon sx={{ fontSize: 12 }} />
        {isActive ? 'Pause' : 'Activate'}
      </button>
      <button
        type="button"
        onClick={() => onEdit(template)}
        style={{
          display: 'flex', alignItems: 'center', gap: 6, fontFamily: fontBody, fontSize: 13, fontWeight: 600,
          color: T.blue, background: 'transparent', border: `1px solid ${T.blue}`,
          padding: '7px 12px', borderRadius: 8, cursor: 'pointer',
        }}
      >
        <Edit3Icon sx={{ fontSize: 13 }} /> Edit flow
      </button>
    </div>
  );
}
